package com.milta.core.localization.translations.it

import com.milta.core.localization.SubscriptionStrings

internal val Subscription = SubscriptionStrings(
    screenTitle = "Il mio abbonamento",
    screenSubtitle = "Gestisci il tuo abbonamento Milta",
    planDriver = "Autista",
    planOrganisation = "Azienda",
    statusActive = "Attivo",
    statusTrial = "Prova gratuita",
    statusExpired = "Scaduto",
    statusCancelled = "Annullato",
    platformLabel = "Piattaforma",
    productIdLabel = "Prodotto",
    expiresAtLabel = "Scade il",
    noExpiry = "Nessuna data di scadenza",
    noValue = "—",
    noSubscription = "Nessun abbonamento attivo",
    activateButton = "Attiva abbonamento",
    successActivated = "Abbonamento attivato con successo",
    perMonth = "/mese",
    pitchTitle = "Sblocca tutte le funzionalità di Milta",
    pitchSubtitle = "Scegli l'offerta adatta alla tua attività per continuare a consegnare e gestire i tuoi giri.",
    featuredBadge = "TUTTO INCLUSO",
    driverFeature1 = "Giri e consegne illimitati",
    driverFeature2 = "Prova di consegna foto + firma",
    driverFeature3 = "Notifiche in tempo reale",
    orgFeature1 = "Gestione team illimitata",
    orgFeature2 = "Dashboard web completa",
    orgFeature3 = "Importazione giri (Excel, PDF, foto)",
    orgFeature4 = "Accesso Autista incluso per te",
    purchaseFinePrint = "Pagamento sicuro tramite lo store. Annullabile in qualsiasi momento dalle impostazioni dello store.",
    purchasingLabel = "Elaborazione in corso…",
    activeCaption = "Il tuo abbonamento Milta",
    nextRenewalLabel = "Prossimo rinnovo",
    includedTitle = "Incluso nella tua offerta",
    manageOnGooglePlay = "Gestisci su Google Play",
    manageOnAppStore = "Gestisci su App Store",
    viewTechnicalDetails = "Vedi dettagli tecnici",
    monthNames = listOf("gennaio", "febbraio", "marzo", "aprile", "maggio", "giugno", "luglio", "agosto", "settembre", "ottobre", "novembre", "dicembre"),
    errorNotFound = "Nessun abbonamento attivo trovato",
    errorConflict = "Esiste già un abbonamento attivo per questo account",
    errorPlanMismatch = "Il piano selezionato non corrisponde al ruolo del tuo account",
    errorPlanRequired = "Seleziona un piano",
    errorPlanInvalid = "Piano selezionato non valido",
    errorPlatformRequired = "La piattaforma è obbligatoria",
    errorPlatformInvalid = "Piattaforma non valida. Deve essere AppStore o GooglePlay",
    errorStoreProductIdRequired = "L'ID prodotto dello store è obbligatorio",
    errorReceiptTokenRequired = "Il token della ricevuta è obbligatorio",
    errorGeneric = "Si è verificato un errore. Riprova.",
    trialBannerDaysPrefix = "🎉 Prova gratuita: ti restano ",
    trialBannerDaysBold = "%d giorni",
    trialBannerDaysSuffix = " per scoprire Milta senza impegno.",
    trialBannerHoursPrefix = "⏰ La tua prova gratuita termina tra ",
    trialBannerHoursBold = "%dh",
    trialBannerHoursSuffix = ": abbonati per continuare a usare Milta senza interruzioni.",
)
